var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,1 C9.86976562,1 11.6276133,1.72813672 12.9497656,3.05023438 C14.2718633,4.37238672 15,6.13023438 15,8 C15,9.86976562 14.2718633,11.6276133 12.9497656,12.9497656 C11.6276133,14.2718633 9.86976562,15 8,15 C6.13023438,15 4.37238672,14.2718633 3.05023438,12.9497656 C1.72813672,11.6276133 1,9.86976562 1,8 C1,6.13023438 1.72813672,4.37238672 3.05023438,3.05023438 C4.37238672,1.72813672 6.13023438,1 8,1 Z M9.5,6.7421875 L6.5,6.7421875 L6.5,12.5 L9.5,12.5 L9.5,6.7421875 Z M8,2.9140625 C7.17074609,2.9140625 6.49609375,3.58871484 6.49609375,4.41796875 C6.49609375,5.24722266 7.17074609,5.921875 8,5.921875 C8.82925391,5.921875 9.50390625,5.24722266 9.50390625,4.41796875 C9.50390625,3.58871484 8.82925391,2.9140625 8,2.9140625 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.55652e5bc1b2e6db71469643d094f18c.svg";
export { ForwardRef as ReactComponent };